import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { ConfigurationOntologiesState, ConfigurationOntology, initialConfigurationOntologiesState } from '@/modules/configurationModule/shared/components/configuration-ontologies/configuration-ontologies.model'
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'

@Component
export default class ConfigurationOntologies<T extends ConfigurationOntology = any> extends Vue {
    @Prop() readonly ontologies!: Array<T>

    @Emit()
    create(): ConfigurationOntologiesState {
        return this.state
    }

    @Emit()
    delete(id: number): number {
        return id
    }

    state: ConfigurationOntologiesState
    constructor() {
        super()
        this.state = initialConfigurationOntologiesState()
    }

    get modelValidated(): boolean {
        return this.canAddOntology(this.state.sampleType?.id, this.state.topographicCode?.id, this.state.procedure?.id, this.state.mostLikelyMorphologicCode?.id)
    }

    async getSampleTypes(): Promise<CommonSampleTypeResponse[]> {
        const response = await this.$_toCallUnique(commonSampleClassificationService.getCommonSampleTypeSampleClassificationsByLaboratory({ laboratoryId: this.state.laboratoryId }))
        return response ?? []
    }

    async getTopographicCodes(): Promise<CommonTopographicCodeResponse[]> {
        const response = await this.$_toCallUnique(commonSampleClassificationService.getCommonTopographicCodesSampleClassificationsByLaboratory({ laboratoryId: this.state.laboratoryId }))
        return response ?? []
    }

    async getProcedures(): Promise<CommonProcedureResponse[]> {
        const response = await this.$_toCallUnique(commonSampleClassificationService.getCommonProceduresSampleClassificationsByLaboratory({ laboratoryId: this.state.laboratoryId }))
        return response ?? []
    }

    async getMostLikelyMorphologicCodes(): Promise<CommonMostLikelyMorphologicCodeResponse[]> {
        const response = await this.$_toCallUnique(commonSampleClassificationService.getCommonMostLikelyMorphologicCodesSampleClassificationsByLaboratory({ laboratoryId: this.state.laboratoryId }))
        return response ?? []
    }

    addOntology(): void {
        this.create()
        this.state = initialConfigurationOntologiesState()
    }

    deleteOntology(ontologyId: number): void {
        this.delete(ontologyId)
    }

    canAddOntology(sampleTypeId?: number, topographicCodeId?: number, procedureId?: number, mostLikelyMorphologicCodeId?: number): boolean {
        const onlySampleType = !!sampleTypeId && !topographicCodeId && !procedureId && !mostLikelyMorphologicCodeId
        const sampleTypeAndTopographicCode = !!sampleTypeId && !!topographicCodeId && !procedureId && !mostLikelyMorphologicCodeId
        const sampleTypeTopographicCodeAndProcedure = !!sampleTypeId && !!topographicCodeId && !!procedureId && !mostLikelyMorphologicCodeId
        const allFieldsSelected = !!sampleTypeId && !!topographicCodeId && !!procedureId && !!mostLikelyMorphologicCodeId
        return onlySampleType || sampleTypeAndTopographicCode || sampleTypeTopographicCodeAndProcedure || allFieldsSelected
    }
}
